import { css } from '@emotion/css';
import { DesignToken, RadiusToken, SpacingToken } from '@livechat/design-system-react-components';

export const banner = css`
  &[class] {
    background-color: var(--brand-green-light, #ebeb01);
    color: var(${DesignToken.ContentLockedDefault});
  }
`;

export const content = css`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  gap: var(${SpacingToken.Spacing2}) var(${SpacingToken.Spacing4});
  width: 100%;
`;

export const message = css`
  display: flex;
  align-items: center;
  gap: var(${SpacingToken.Spacing2});
  flex: 0 1 auto;
  min-width: 0;
  max-width: max-content;
  text-align: left;
  line-height: 21px;
  text-wrap: balance;

  > :first-child {
    flex-shrink: 0;
  }
`;

export const action = css`
  &[class] {
    flex-shrink: 0;
    min-height: 32px;
    padding: 0 var(${SpacingToken.Spacing4});
    border-radius: var(${RadiusToken.Radius3});
    background-color: var(${DesignToken.SurfaceLockedWhite});
    border: 1px solid #c9c9cd;
    color: var(${DesignToken.ContentLockedDefault});
  }
`;
